import React,{useState,useEffect,useContext,createContext} from 'react'
import {Route,Routes,Navigate,useNavigate,BrowserRouter,Switch} from 'react-router-dom'
import Registration from './components/Registration'
import Badge from './components/Badge'
export default function App() {
  return (
    <>
      <BrowserRouter basename="/visitorsregistration">
        <Routes>
          <Route path='/:exURL/onsite' element={<Registration/>}/>
          <Route path='/:exURL' element={<Registration/>}/>
          <Route path='/:exURL/badge/:barcode' element={<Badge/>}/>
        </Routes>
      </BrowserRouter>
    
    </>
  )
}
